module.exports = __webpack_public_path__ + "img/amelia_logo.7786815c.jpg";